module.exports = __webpack_public_path__ + "static/cap@2x-eb468a99ee520a91c2dc271bdf8a3f18.png";